<template>
    <div class="main">
        <c-panel title="PAINEL DE RISCO" titleIcon="fas fa-chart-pie">
            <el-alert type="warning" :closable="false" class="u-mb-15"
                title="Indicador de risco, não determinação sobre o aluno."
                :description="painel ? painel.aviso_metodologico : 'O score é calculado sobre dados do próprio sistema e vem sempre com os fatores que o produziram.'"></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Indicador" class="u-mb-0">
                            <el-select v-model="configuracaoId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="c in configuracoes" :key="c.id" :value="c.id" :label="c.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" clearable filterable placeholder="Toda a rede" style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="9" class="u-text-right u-mt-25">
                        <el-button v-if="podeCalcular" type="primary" size="small" icon="el-icon-cpu"
                            :disabled="!configuracaoId" @click="calcular">CALCULAR AGORA</el-button>
                        <el-button class="u-ml-10" size="small" icon="el-icon-printer" :disabled="!painel || !painel.data_referencia" @click="imprimir">IMPRIMIR</el-button>
                        <el-button class="u-ml-10" size="small" icon="el-icon-pie-chart" :disabled="!podeVerVies || !configuracaoId" @click="abrirVies">VIÉS</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="painel && painel.aviso" type="info" :closable="false" class="u-mb-15" :title="painel.aviso"></el-alert>

            <div v-if="painel && painel.kpis.total > 0">
                <div class="u-mb-10">
                    <small class="u-text-muted">
                        {{ painel.rotulo_objetivo }} · apurado em {{ dataBr(painel.data_referencia) }}
                        <span v-if="painel.modelo">
                            · modelo {{ painel.modelo.versao }} ({{ painel.modelo.origem }})
                            <span v-if="painel.modelo.tem_metricas">· acurácia {{ pct(painel.modelo.acuracia) }}</span>
                            <span v-else>· <em>sem métricas de validação</em></span>
                        </span>
                    </small>
                </div>

                <el-row :gutter="10" class="u-mb-20">
                    <el-col :xs="12" :sm="6"><div class="kpi kpi-alto" @click="filtrarRisco('alto')"><span class="n">{{ painel.kpis.alto }}</span><span class="r">Risco alto</span></div></el-col>
                    <el-col :xs="12" :sm="6"><div class="kpi kpi-medio" @click="filtrarRisco('medio')"><span class="n">{{ painel.kpis.medio }}</span><span class="r">Risco médio</span></div></el-col>
                    <el-col :xs="12" :sm="6"><div class="kpi kpi-baixo" @click="filtrarRisco('baixo')"><span class="n">{{ painel.kpis.baixo }}</span><span class="r">Risco baixo</span></div></el-col>
                    <el-col :xs="12" :sm="6"><div class="kpi" @click="filtrarRisco('')"><span class="n">{{ painel.kpis.total }}</span><span class="r">Alunos avaliados</span></div></el-col>
                </el-row>

                <!-- ==================== MAPA DE CALOR ==================== -->
                <h4 class="u-mb-10">Distribuição por escola</h4>
                <div class="container-table u-mb-20">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th style="width: 90px;" class="u-text-center">Alto</th>
                                <th style="width: 90px;" class="u-text-center">Médio</th>
                                <th style="width: 90px;" class="u-text-center">Baixo</th>
                                <th style="width: 90px;" class="u-text-center">Total</th>
                                <th style="width: 220px;">% em risco alto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="e in painel.por_escola" :key="e.instituicao_id">
                                <td>{{ e.instituicao }}</td>
                                <td class="u-text-center">{{ e.alto }}</td>
                                <td class="u-text-center">{{ e.medio }}</td>
                                <td class="u-text-center">{{ e.baixo }}</td>
                                <td class="u-text-center">{{ e.total }}</td>
                                <td>
                                    <div class="barra">
                                        <div class="barra-preenchida" :style="{ width: e.perc_alto + '%', background: corCalor(e.perc_alto) }"></div>
                                        <span class="barra-texto">{{ e.perc_alto }}%</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4 class="u-mb-10">Turmas com maior concentração de risco alto</h4>
                <div class="container-table u-mb-20">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Turma</th>
                                <th style="width: 90px;" class="u-text-center">Alto</th>
                                <th style="width: 90px;" class="u-text-center">Total</th>
                                <th style="width: 220px;">% em risco alto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="t in painel.por_turma.slice(0, 15)" :key="t.turma_id">
                                <td>{{ t.turma }}</td>
                                <td class="u-text-center">{{ t.alto }}</td>
                                <td class="u-text-center">{{ t.total }}</td>
                                <td>
                                    <div class="barra">
                                        <div class="barra-preenchida" :style="{ width: t.perc_alto + '%', background: corCalor(t.perc_alto) }"></div>
                                        <span class="barra-texto">{{ t.perc_alto }}%</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- ==================== ALUNOS ==================== -->
                <h4 class="u-mb-10">
                    Alunos
                    <small v-if="filtro.classificacao_risco" class="u-text-muted">— filtrando risco {{ filtro.classificacao_risco }}</small>
                </h4>

                <el-row :gutter="10" class="u-mb-10">
                    <el-col :xs="24" :sm="8">
                        <el-input v-model="filtro.aluno" size="small" placeholder="Pesquisar aluno..." @keyup.native.enter="carregarLista"></el-input>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-select v-model="filtro.classificacao_risco" clearable size="small" placeholder="Risco" style="width: 100%;" @change="carregarLista">
                            <el-option value="alto" label="Alto"></el-option>
                            <el-option value="medio" label="Médio"></el-option>
                            <el-option value="baixo" label="Baixo"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Aluno</th>
                                <th style="width: 120px;" class="hidden-mobile">Turma</th>
                                <th style="width: 90px;" class="u-text-center">Score</th>
                                <th style="width: 90px;" class="u-text-center">Risco</th>
                                <th>Fatores que mais pesaram</th>
                                <th style="width: 100px;" class="u-text-center">Ficha</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="i in lista" :key="i.id">
                                <td>{{ i.aluno_nome }}</td>
                                <td class="hidden-mobile">{{ i.turma_nome }}</td>
                                <td class="u-text-center">{{ i.score_percentual }}%</td>
                                <td class="u-text-center">
                                    <el-tag size="mini" :type="corRisco(i.classificacao_risco)">{{ i.classificacao_risco }}</el-tag>
                                </td>
                                <td>
                                    <small v-if="i.fatores && i.fatores.length">
                                        <span v-for="(f, k) in i.fatores" :key="k">
                                            {{ f.rotulo }}<span v-if="!f.dado_disponivel" class="u-text-muted"> (sem dado)</span><span v-if="k < i.fatores.length - 1"> · </span>
                                        </span>
                                    </small>
                                    <small v-else class="u-text-muted">—</small>
                                </td>
                                <td class="u-text-center">
                                    <router-link :to="'/admin/preditivo/aluno?configuracao=' + configuracaoId + '&matricula=' + i.matricula_id">
                                        <el-button size="mini" plain>ABRIR</el-button>
                                    </router-link>
                                </td>
                            </tr>
                            <tr v-if="lista.length === 0"><td colspan="6" class="u-text-center">Nenhum aluno para os filtros informados.</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- ==================== VIÉS (K.6) ==================== -->
            <el-dialog title="Distribuição de risco por perfil — monitoramento de viés" :visible.sync="dialogoVies" width="760px">
                <el-alert v-if="vies" type="warning" :closable="false" class="u-mb-15" :title="vies.aviso"></el-alert>
                <div v-if="vies">
                    <div v-for="(linhas, dimensao) in vies.dimensoes" :key="dimensao" class="u-mb-20">
                        <h4 class="u-mb-10">{{ rotuloDimensao(dimensao) }}</h4>
                        <div class="container-table">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Categoria</th>
                                        <th style="width: 80px;" class="u-text-center">Alto</th>
                                        <th style="width: 80px;" class="u-text-center">Total</th>
                                        <th style="width: 200px;">% em risco alto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="l in linhas" :key="l.categoria">
                                        <td>{{ rotuloCategoria(dimensao, l.categoria) }}</td>
                                        <td class="u-text-center">{{ l.alto }}</td>
                                        <td class="u-text-center">{{ l.total }}</td>
                                        <td>
                                            <div class="barra">
                                                <div class="barra-preenchida" :style="{ width: l.perc_alto + '%', background: corCalor(l.perc_alto) }"></div>
                                                <span class="barra-texto">{{ l.perc_alto }}%</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <span slot="footer"><el-button @click="dialogoVies = false">FECHAR</el-button></span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO K — itens 135, 136, 139 e 140: painel de risco com mapa de calor. */
import { SEXO, RACA_COR, LOCALIZACAO_ZONA } from '@/shared/constants'

export default {
    data: () => ({
        configuracaoId: null, instituicaoId: null, configuracoes: [], instituicoes: [],
        painel: null, lista: [], filtro: { classificacao_risco: '', aluno: '' },
        dialogoVies: false, vies: null
    }),
    computed: {
        podeCalcular () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) },
        podeVerVies () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        const periodo = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : ''

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/preditivo/configuracao/getAll/${periodo}`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            this.configuracoes = Array.isArray(r.data) ? r.data : []
            if (this.$route.query.configuracao) this.configuracaoId = parseInt(this.$route.query.configuracao)
            else if (this.configuracoes.length) this.configuracaoId = this.configuracoes[0].id
            if (this.configuracaoId) this.carregar()
        }).catch(e => this.$store.commit('throwException', e))

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
    },
    methods: {
        carregar () {
            this.painel = null; this.lista = []
            if (!this.configuracaoId) return

            const base = `${this.$store.state.config.baseUrlApi}/api/preditivo/painel/${this.configuracaoId}`
            const url = this.instituicaoId ? `${base}/${this.instituicaoId}` : base

            this.$axios.get(url, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.painel = r.data
                if (this.painel.kpis.total > 0) this.carregarLista()
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregarLista () {
            const payload = Object.assign({}, this.filtro)
            if (this.instituicaoId) payload.instituicao_id = this.instituicaoId

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/preditivo/listar/${this.configuracaoId}`,
                payload, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) return
                this.lista = (r.data.itens || []).slice(0, 200)
            }).catch(e => this.$store.commit('throwException', e))
        },
        filtrarRisco (r) { this.filtro.classificacao_risco = r; this.carregarLista() },
        calcular () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/preditivo/calcular/${this.configuracaoId}`,
                {}, this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', {
                    msg: `${r.data.calculados} score(s) calculado(s) — alto ${r.data.por_risco.alto}, médio ${r.data.por_risco.medio}, baixo ${r.data.por_risco.baixo}.`,
                    type: 'success'
                })
                this.carregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        abrirVies () {
            this.vies = null
            this.dialogoVies = true
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/preditivo/vies/${this.configuracaoId}`,
                {}, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); this.dialogoVies = false; return }
                this.vies = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        imprimir () {
            const param = { classificacao_risco: this.filtro.classificacao_risco }
            if (this.instituicaoId) param.instituicao_id = this.instituicaoId

            window.eventBus.$emit('print', {
                url: `/api/preditivo/imprimirRelatorio/${this.configuracaoId}`,
                param: param
            })
        },
        corRisco (r) { return { alto: 'danger', medio: 'warning', baixo: 'success' }[r] || 'info' },
        /** Verde → amarelo → vermelho conforme a concentração de risco alto. */
        corCalor (p) {
            if (p >= 30) return '#f56c6c'
            if (p >= 15) return '#e6a23c'
            if (p > 0) return '#67c23a'
            return '#dcdfe6'
        },
        rotuloDimensao (d) {
            return { raca_cor: 'Raça/cor', sexo: 'Sexo', localizacao_zona: 'Zona (urbana/rural)' }[d] || d
        },
        /**
         * O backend agrupa pelo código cru da coluna (`sexo` 0/1, `localizacao_zona` 1/2).
         * Esta é a tela que responde "o modelo discrimina?" — mostrar "0" e "1" onde se
         * espera "Masculino" e "Feminino" obriga quem lê a adivinhar justamente aqui.
         */
        rotuloCategoria (dimensao, valor) {
            if (valor === 'nao_informado' || valor === null || valor === '') return 'Não informado'
            const mapas = { sexo: SEXO, raca_cor: RACA_COR, localizacao_zona: LOCALIZACAO_ZONA }
            const m = mapas[dimensao]
            if (!m) return valor
            const r = m[parseInt(valor)]
            return r ? r.charAt(0) + r.slice(1).toLowerCase() : valor
        },
        pct (v) { return v !== null && v !== undefined ? (parseFloat(v) * 100).toFixed(1) + '%' : '—' },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.kpi { border: 1px solid #dcdfe6; border-radius: 4px; padding: 12px; text-align: center; margin-bottom: 8px; cursor: pointer; }
.kpi:hover { border-color: #409eff; }
.kpi .n { display: block; font-size: 24px; font-weight: bold; }
.kpi .r { display: block; font-size: 12px; color: #606266; margin-top: 2px; }
.kpi-alto { border-left: 4px solid #f56c6c; }
.kpi-medio { border-left: 4px solid #e6a23c; }
.kpi-baixo { border-left: 4px solid #67c23a; }
.barra { position: relative; background: #f0f2f5; border-radius: 3px; height: 18px; }
.barra-preenchida { height: 18px; border-radius: 3px; }
.barra-texto { position: absolute; top: 0; left: 6px; font-size: 11px; line-height: 18px; }
</style>
